import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination } from "swiper/modules";
import paraCable from "../../assets/img/service/paradise-cables-ltd.jpg";
import { useEffect } from "react";
import ChatBox from "../card/ChatBox";
import { Link } from "react-router-dom";
import QuotationRequest from "../card/QuotationRequest";

const ElectricianDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-16 Corporate_Blue_bg relative">
      
      <div className="">
        <div className="mx-auto px-4 py-8">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full md:w-1/12 hidden md:block px-4 mb-8"></div>
            <div className="w-full md:w-5/12 px-4 mb-8 details-img bg-white bg-opacity-5">
              <Swiper
                effect={"coverflow"}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={"auto"}
                coverflowEffect={{
                  rotate: 50,
                  stretch: 0,
                  depth: 100,
                  modifier: 1,
                  slideShadows: true,
                }}
                pagination={true}
                modules={[EffectCoverflow, Pagination]}
                className="mySwiper "
              >
                <SwiperSlide>
                  <img
                    src={paraCable}
                    alt="Product"
                    className="w-full h-auto rounded-lg shadow-md mb-4"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src="https://images.pexels.com/photos/5691590/pexels-photo-5691590.jpeg"
                    alt="Product"
                    className="w-full h-auto rounded-lg shadow-md mb-4"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src="https://images.pexels.com/photos/5691642/pexels-photo-5691642.jpeg"
                    alt="Product"
                    className="w-full h-auto rounded-lg shadow-md mb-4"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src="https://images.pexels.com/photos/442160/pexels-photo-442160.jpeg"
                    alt="Product"
                    className="w-full h-auto rounded-lg shadow-md mb-4"
                  />
                </SwiperSlide>
              </Swiper>
            </div>

            <div className="w-full md:w-5/12 px-4">
              <h2 className="text-3xl font-bold mb-2 Orange_Yellow">
                Paradise Cable Ltd.
              </h2>
              <div className="flex items-center mb-4"></div>
              <p className="Light_Grey mb-6 pr-9">
                Top expert electricians & electrical service provider in Dhaka,
                Bangladesh. Icon Services has been caring entire electrical
                service for 15 years.
              </p>
              <div className="flex flex-wrap items-start  pb-5">
                <Link
                  className=" relative px-3 py-1 m-2 rounded-md shadow-sm sm:py-2 sm:text-base ring ring-transparent group md:px-4 hover:ring hover:ring-opacity-50 focus:ring-opacity-50 hover:ring-[#F6AE28] text-[#191308] bg-[#D1D1D1] dark:bg-gray-400 dark:text-gray-200 "
                  to={"#"}
                >
                  <span className="text-sm">Cable</span>
                </Link>
                <Link
                  className=" relative px-3 py-1 m-2 rounded-md shadow-sm sm:py-2 sm:text-base ring ring-transparent group md:px-4 hover:ring hover:ring-opacity-50 focus:ring-opacity-50 hover:ring-[#F6AE28] text-[#191308] bg-[#D1D1D1] dark:bg-gray-400 dark:text-gray-200 "
                  to={"#"}
                >
                  <span className="text-sm">Electrician</span>
                </Link>
                <Link
                  className=" relative px-3 py-1 m-2 rounded-md shadow-sm sm:py-2 sm:text-base ring ring-transparent group md:px-4 hover:ring hover:ring-opacity-50 focus:ring-opacity-50 hover:ring-[#F6AE28] text-[#191308] bg-[#D1D1D1] dark:bg-gray-400 dark:text-gray-200 "
                  to={"#"}
                >
                  <span className="text-sm">Wiring</span>
                </Link>
                <Link
                  className=" relative px-3 py-1 m-2 rounded-md shadow-sm sm:py-2 sm:text-base ring ring-transparent group md:px-4 hover:ring hover:ring-opacity-50 focus:ring-opacity-50 hover:ring-[#F6AE28] text-[#191308] bg-[#D1D1D1] dark:bg-gray-400 dark:text-gray-200 "
                  to={"#"}
                >
                  <span className="text-sm">Wholesale</span>
                </Link>
              </div>
              <button
                onClick={() =>
                  document.getElementById("chatBox_modal").showModal()
                }
                className="bg-[#B80000] rounded-full px-6 ml-2 mt-2 h-7 sm:h-16 text-white font-semibold"
              >
                <div className="flex gap-3 justify-center items-center">
                  <span>
                    <img
                      className="w-5 sm:w-8"
                      src="https://img.icons8.com/?size=100&id=7859&format=png&color=F6AE28"
                      alt="chatIcon"
                    />
                  </span>
                  <span className="text-lg sm:text-2xl capitalize">Text us</span>
                </div>
              </button>
              <button
                onClick={() =>
                  document.getElementById("quotationRequest_modal").showModal()
                }
                className="bg-[#B80000] rounded-full px-5 ml-2 mt-2 h-7 sm:h-16 text-white font-semibold"
              >
                <div className="flex gap-3 justify-center items-center">
                  <span>
                    <img
                      className="w-5 sm:w-8"
                      src="https://img.icons8.com/?size=100&id=iTU2embwsZhE&format=png&color=F6AE28"
                      alt="chatIcon"
                    />
                  </span>
                  <span className="text-lg sm:text-2xl capitalize">Quotation Request</span>
                </div>
              </button>
            </div>
            <div className="w-full md:w-1/12 hidden md:block px-4 mb-8"></div>
          </div>
        </div>
        <div className="mx-auto px-4 py-8">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full md:w-2/12 px-4 mb-8"></div>
            <div className="w-full md:w-10/12 px-4 mb-8 ">
              <div className="">
                <div className="md:grid md:grid-cols-2 md:gap-x-2 md:gap-y-8">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-amber-600 text-white">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <dt className="text-lg leading-6 Light_Grey font-semibold">
                        Address
                      </dt>
                      <dd className="mt-2 text-base Light_Grey">
                        Paradise Tower (7th, 10th & 11th Floor) <br></br>
                        Plot# 11, Sector# 03, Dhaka- 1230, Bangladesh
                      </dd>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-amber-600 text-white">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <dt className="text-lg leading-6 font-semibold Light_Grey">
                        Phone number
                      </dt>
                      <dd className="mt-2 text-base Light_Grey">
                        +880-2-98615978
                      </dd>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-amber-600 text-white">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <dt className="text-lg leading-6 font-semibold Light_Grey">
                        Email
                      </dt>
                      <dd className="mt-2 text-base Light_Grey">
                        info@paradisecable.com
                      </dd>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-amber-600 text-white">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <dt className="text-lg leading-6 font-semibold Light_Grey">
                        Store Hours
                      </dt>
                      <div className="mt-2 text-base Light_Grey">
                        Monday - Friday: 9am to 8pm<br></br>
                        Saturday: 10am to 6pm<br></br>
                        Sunday: 12pm to 4pm
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* chat box modal  */}
      <ChatBox name={"Paradise Cable Ltd."} />
      <QuotationRequest />
      {/* chat box modal  */}
    </div>
  );
};

export default ElectricianDetails;
